import { SampleType } from '../../interfaces/garments/sampleRequest.interface';

/**
 * Every backend `SampleType` value (mirrors `com.kervolt.oms.enums.SampleType`). Single source for
 * the type dropdown so `SampleRequestForm` and `SampleRequestList` can't drift apart the way two
 * copy-pasted literals could.
 */
export const SAMPLE_TYPES: SampleType[] = ['LAB_DIP', 'SALESMAN', 'PROTO', 'FIT', 'SIZE_SET', 'PP', 'TOP', 'SHIPMENT'];
